import React from 'react';
import Link from 'components/Link';
import BottomSearch from 'components_v2/mobile/BottomSearch/BottomSearchLoader';
import AddOrgSchema from 'components_v2/common/AddOrgSchema';
import { gaWrapper } from 'helpers/analytics';
import RenderAds from 'routes/home/components/desktop/RenderAds/RenderAds';
import s from './ListingHeader.scss';
import {
  IMAGE_URL,
  REVIEWS_LIVE_DOMAIN,
  TOI_LIVE_DOMAIN,
} from '../../../constants';

const ListingHeader = data => {
  let getSubSection =
    data.headerLabel || (data.data && data.data.split('-')[1]);
  getSubSection = data.mastheadText ? data.mastheadText : getSubSection;
  const isExpandedSearchBarVisible = data.isExpandedSearchBarVisible || false;
  const sponsoredAd = data.sponsoredAds || '';
  const enableHeaderUnificationVersion =
    data && data.enableHeaderUnificationVersion;
  const APIUrl =
    'https://timesofindia.indiatimes.com/feeds/web_navigation_feed_spadata.cms?category=changecity&feedtype=sjson';
  const listAPIUrl = __PROD__
    ? APIUrl
    : APIUrl.replace('timesofindia.indiatimes', 'toidev.indiatimes');
  const { isTechnology } = data;

  const getSiteTopLogoLink = () => {
    let logoMsid = isTechnology ? '109343604' : '92222747';
    let ariaLabel = 'Times of India';
    let url = `${TOI_LIVE_DOMAIN}${isTechnology ? '/technology' : ''}`;
    let logoClassName = '';
    if (data.isReviewsPage) {
      url = REVIEWS_LIVE_DOMAIN;
      logoMsid = '113492625';
      ariaLabel = 'Times Reviews';
      logoClassName = s.reviewMlogo;
    }
    return (
      <a
        href={url}
        onClick={() => {
          gaWrapper(
            'send',
            'event',
            'mobile_unified_header',
            'click_H3_toi_title_click',
            `${data.selectedTab}_${data.pageType}`,
          );
        }}
        aria-label={ariaLabel}
      >
        <img
          className={logoClassName}
          src={`${IMAGE_URL}${logoMsid}.cms`}
          alt=""
          title=""
        />
      </a>
    );
  };
  const insertJsx = (
    <div className={`${s.logo} ${isTechnology ? s.gnLogo : ''}`}>
      {data?.pageType === 'Listing' || enableHeaderUnificationVersion ? (
        getSiteTopLogoLink()
      ) : (
        <>
          <Link
            to={TOI_LIVE_DOMAIN}
            aria-label="Times of India"
            className={s.logoImg}
          />
          {data.h1Required ? (
            <h1>{getSubSection}</h1>
          ) : (
            <span>{getSubSection}</span>
          )}
          {sponsoredAd && <RenderAds adObject={sponsoredAd} isWapView />}
        </>
      )}
    </div>
  );
  const ModifiedJsx = AddOrgSchema(
    insertJsx,
    false,
    true,
    data.pageCanonicalUrl,
  );
  return (
    <div
      className={`${s.listingHeader} ${
        isExpandedSearchBarVisible &&
        !(data.data && data.data.split('-')[1] === 'city')
          ? s.searchExpand
          : ''
      }`}
    >
      <ModifiedJsx />
      {data?.pageType === 'Listing' || enableHeaderUnificationVersion
        ? null
        : data.data &&
          data.data.split('-')[1] === 'city' && (
            <div className={s.changeCity}>
              <BottomSearch
                data={listAPIUrl}
                showSearchBox
                iconClass={s.cityIcon}
                dropdownTitle="City"
                sectionName={
                  data.headerLabel || (data.data && data.data.split('-')[2])
                }
                // gaData={{
                //   gaAction: `${sectionData.name}-TabChange`,
                //   partialGaLabel: 'Click',
                // }}
                // toggleLoader={this.toggleLoader}
                // headingname={sectionData.name}
                // headingLink={sectionData.link || sectionData.path}
                // linkData={{
                //   gaAction,
                //   gaLabel: 'Click-Header',
                // }}
              />
            </div>
          )}
    </div>
  );
};

// ListingHeader.propTypes = {
//   data: PropTypes.objectOf({}),
// };
// ListingHeader.defaultProps = {
//   data: {},
// };

export default React.memo(ListingHeader);
